import type { AppProps } from 'next/app';
import { ApolloProvider } from '@apollo/client';

import { CurrentAccountIdProvider } from '@zapier/identity';
import { PreviousUrlProvider } from '@zapier/auth-pages';
import { GlobalStylesProvider } from '@zapier/design-system';
import {
  TrackingProvider,
  TrackRouting,
  initializeDatadogRum,
  nextJsReportWebVitals,
  FullStory,
} from '../observability';
import { getOrCreateApolloClient } from '../apollo/getOrCreateApolloClient';
import { isInIframe } from '@zapier/identity-utils';

// Measure and report web vitals that Next.js tracks to Datadog.
// See: https://nextjs.org/docs/advanced-features/measuring-performance
initializeDatadogRum();
export const reportWebVitals = nextJsReportWebVitals;

function App({ Component, pageProps }: AppProps) {
  const apolloClient = getOrCreateApolloClient();
  if (typeof window === 'undefined') {
    return <></>;
  }

  return (
    <ApolloProvider client={apolloClient}>
      <CurrentAccountIdProvider>
        <PreviousUrlProvider>
          <TrackingProvider>
            <TrackRouting>
              <GlobalStylesProvider isRebrand={true} isPlatform={true}>
                <Component {...pageProps} />
              </GlobalStylesProvider>
            </TrackRouting>
          </TrackingProvider>
        </PreviousUrlProvider>
      </CurrentAccountIdProvider>
      {!isInIframe() && <FullStory />}
    </ApolloProvider>
  );
}

export default App;
